/* unplugin-vue-components disabled */import { render } from "./dataShow.vue?vue&type=template&id=40b161ef"
import script from "./dataShow.vue?vue&type=script&lang=js"
export * from "./dataShow.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__